import { ADIRToddlerParsedResult } from "@api/assessments/assessment-schema-types";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

export const ADI_R_TODDLER_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: ADIRToddlerParsedResult,
  sections: [
    {
      type: "text_field",
      key: "Header.Date of ADI-R Administration",
      label: "Date of ADI-R Administration",
      editable: true,
      validation: { inputType: "date" },
    },
    {
      type: "text_field",
      key: "Header.Participant ID",
      label: "Participant ID",
      editable: false,
    },
    {
      type: "grouped_rows",
      label: "Algorithm Scores",
      source: "Rows",
      groupBy: ["algorithm_name", "section_heading"],
      nameKey: "subheading",
      rowLayoutKey: "row_layout",
      columns: {
        code: { label: "Code", editable: true },
        score: { label: "Score", editable: true },
        value: { label: "Value", editable: true },
      },
    },
  ],
};
